/* © CNES */
import { Divider } from 'primereact/divider';
/**
 * CustomSection
 * @param title Title of the custom section.
 * @param children React Component to show as child.
 * @returns
 */
export const CustomSection = ({
  title,
  children,
}: {
  title: string;
  children: JSX.Element | JSX.Element[];
}) => {
  return (
    <>
      {!!title && (
        <div>
          <h2 className="SectionTitle">{title}</h2>
          <Divider />
        </div>
      )}
      {children}
    </>
  );
};
